import { Loader } from 'components';
import { PROFILE_ROUTES, ROUTES } from 'configs';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import {
  clearSubscriptionPlanId,
  getAllSubscriptions,
  getCurrentUserSubscription,
} from 'store/actionCreators/subscriptions';
import {
  selectAllSubscriptions,
  selectHasPlansData,
  selectIsPlansInitialLoading,
} from 'store/selectors/subscriptions';
import { SubscriptionPlan } from 'types';

import { Content } from '../styled';
import * as Ch from './styled';
import SubscriptionsInnerComponent from './SubscriptionInner';

export type CheckoutLocationState = {
  checkoutPlan?: SubscriptionPlan;
  activeCommunityIds?: string[];
};

const CheckoutPlanMissing = () => {
  const { t } = useTranslation();
  const changePlanPath = `${ROUTES.PROFILE}/${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.CHANGE_PLAN}`;

  return (
    <Content>
      <Ch.CheckoutPlanMissingWrap>
        <Ch.CheckoutPlanMissingText>
          {t('subscriptions.checkout.planNotInCatalog')}
        </Ch.CheckoutPlanMissingText>
        <Ch.CheckoutPlanMissingLink to={changePlanPath}>
          {t('subscriptions.checkout.backToChangePlan')}
        </Ch.CheckoutPlanMissingLink>
      </Ch.CheckoutPlanMissingWrap>
    </Content>
  );
};

const SubscriptionsInnerPageContainer = () => {
  const { subscriptionId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const subscriptions = useSelector(selectAllSubscriptions);
  const hasPlansData = useSelector(selectHasPlansData);
  const isPlansInitialLoading = useSelector(selectIsPlansInitialLoading);

  const state = (location.state || {}) as CheckoutLocationState;
  const planFromState =
    state.checkoutPlan && state.checkoutPlan.id === subscriptionId
      ? state.checkoutPlan
      : undefined;
  const activeCommunityIdsFromState = state.activeCommunityIds?.length
    ? state.activeCommunityIds
    : undefined;
  useEffect(() => {
    dispatch(getAllSubscriptions.trigger({ silent: false }));
    dispatch(getCurrentUserSubscription.trigger());

    return () => {
      dispatch(clearSubscriptionPlanId());
    };
  }, [dispatch]);

  if (planFromState) {
    return (
      <SubscriptionsInnerComponent
        planFallback={planFromState}
        initialActiveCommunityIds={activeCommunityIdsFromState}
      />
    );
  }

  if (isPlansInitialLoading && !hasPlansData) {
    return <Loader />;
  }

  const catalogMatch = subscriptions.find(({ id }) => id === subscriptionId);
  if (catalogMatch) {
    return (
      <SubscriptionsInnerComponent
        initialActiveCommunityIds={activeCommunityIdsFromState}
      />
    );
  }

  return <CheckoutPlanMissing />;
};

export default SubscriptionsInnerPageContainer;
